import BroadcastTable from './BroadcastTable';

export default BroadcastTable;
